import {useEffect, useState} from "react";
import {useRestClient} from "../client/SpmRestClient";
import {Spinner} from "react-bootstrap";
import {NamedEntityCheckboxGroup} from "zavadil-react-common";
import {TargetGroup} from "../types/TargetGroup";
import {useAlerts} from "../utils/UserAlerts";

export type SelectTargetGroupsProps = {
	selectedGroupIds: Array<number>;
	onChange(selectedGroupIds: Array<number>): any;
}

export default function SelectTargetGroups({selectedGroupIds, onChange}: SelectTargetGroupsProps) {
	const restClient = useRestClient();
	const userAlerts = useAlerts();
	const [groups, setGroups] = useState<Array<TargetGroup>>();

	useEffect(() => {
			restClient.targetGroups.all()
				.then(setGroups)
				.catch((e) => userAlerts.err(e));
		},
		[]
	);

	return groups ? <NamedEntityCheckboxGroup
		items={groups}
		selectedIds={selectedGroupIds}
		onChange={onChange}
	/> : <Spinner/>
}
